const SvgProfileIcon2 = ({ stroke = '#444CE7' }) => {
  return (
    <>
      <svg
        width="15"
        height="14"
        viewBox="0 0 15 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.9998 13V11.6667C13.9998 10.4241 13.15 9.38004 11.9998 9.08401M9.6665 1.19384C10.6438 1.58943 11.3332 2.54754 11.3332 3.66667C11.3332 4.78579 10.6438 5.7439 9.6665 6.13949M10.6665 13C10.6665 11.7575 10.6665 11.1362 10.4635 10.6462C10.1929 9.99277 9.67373 9.47364 9.02033 9.20299C8.53027 9 7.90902 9 6.6665 9H4.6665C3.42399 9 2.80274 9 2.31268 9.20299C1.65927 9.47364 1.14014 9.99277 0.869492 10.6462C0.666504 11.1362 0.666504 11.7575 0.666504 13M8.33317 3.66667C8.33317 5.13943 7.13926 6.33333 5.6665 6.33333C4.19374 6.33333 2.99984 5.13943 2.99984 3.66667C2.99984 2.19391 4.19374 1 5.6665 1C7.13926 1 8.33317 2.19391 8.33317 3.66667Z"
          stroke={stroke}
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  )
}

export default SvgProfileIcon2
